import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const sendAnnouncement = async (id: number): Promise<void> => {
	await cmsClient.post(`/announcements/${id}/send/`);
};

const useSendAnnouncement = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Announcement sent successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["announcements"]);
	};

	const onError = (error: unknown) => {
		const axiosError = error as AxiosError;
		const message =
			axiosError?.response?.status === 409
				? "This announcement has already been sent."
				: "Something went wrong, try again";
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(sendAnnouncement, {
		onError,
		onSuccess,
		onSettled
	});
	return mutation;
};

export default useSendAnnouncement;
